import { useMutation, useQueryClient } from 'react-query';
import { useWarningToast } from '../../../../presentation/hooks/useWarningToast';
import {
  retryChargeAutoTopUp,
  type RetryChargeAutoTopUpResponse
} from '../../services/bettieAutoTopUpService';

export function useRetryChargeAutoTopUp() {
  const queryClient = useQueryClient();
  const showWarningToast = useWarningToast();
  return useMutation<RetryChargeAutoTopUpResponse, Error, string>(
    (bettieAutoTopUpId: string) => retryChargeAutoTopUp(bettieAutoTopUpId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['bettieAutoTopUp']);
      },
      onError: (error) => {
        showWarningToast(
          'bottom',
          (error as { error?: { message?: string } })?.error?.message as string
        );
      }
    }
  );
}
